import { Type } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { SortType } from '@payments/models/state-model';
import { SortDirection, SortFilter } from '@usf/ngrx-payment';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerSelectionOption } from '../../../../customer/models/customer-selection-option.model';
import { CustomerSelectionVM } from '../../../../customer/models/customer-selection-vm.model';

export interface ModalFilter {
  filterName: string;
  component?: Type<any>;
  data: ModalFilterDataType;
}

export interface ModalSort {
  sortName: SortType;
  sortDirection: SortDirection;
  label: string;
}

export type ModalFilterDataType =
  | ModalFilterListData
  | ModalFilterCalendarData
  | ModalFilterCustomerData
  | ModalFilterTextData
  | ModalSortOptionsData;

export interface ModalFilterData {
  title: string;
  subTitle$?: BehaviorSubject<string>;
}

export interface ModalFilterListData extends ModalFilterData {
  canSelectMultiple?: boolean;
  canSelectAll?: boolean;
  data?: Map<string, string>;
  newSelectedData?: string[];
}

export interface ModalFilterCalendarData extends ModalFilterData {
  //YYYYmmDD
  fromDate: number;
  //YYYYmmDD
  toDate: number;
  maxDate?: Date;
  minDate?: Date;
  message?: string;
}

export interface ModalFilterTextData extends ModalFilterData {
  placeHolderText: string;
  searchText: string;
  validationRegex?: RegExp;
}

export interface ModalSortOptionsData extends ModalFilterData {
  sortOptions: ModalSort[];
  sortSelection: SortFilter[];
  platformType: PlatformEnum;
}

export interface ModalFilterCustomerData extends ModalFilterData {
  searchText$: BehaviorSubject<string>;
  vm$: Observable<CustomerSelectionVM>;
  isPresentedInFilterModal: boolean;
  show: boolean;
  selectedCustomers: CustomerSelectionOption[];
}

export function isFilterListData(
  filterData: ModalFilterDataType,
): filterData is ModalFilterListData {
  return (filterData as ModalFilterListData).newSelectedData !== undefined;
}

export function isFilterCalendarData(
  filterData: ModalFilterDataType,
): filterData is ModalFilterCalendarData {
  return (filterData as ModalFilterCalendarData).fromDate !== undefined;
}

export function isFilterCustomerData(
  filterData: ModalFilterDataType,
): filterData is ModalFilterCustomerData {
  return (filterData as ModalFilterCustomerData).vm$ !== undefined;
}

export function isFilterTextEntryData(
  filterData: ModalFilterDataType,
): filterData is ModalFilterTextData {
  return (filterData as ModalFilterTextData).searchText !== undefined;
}

export function isSortOptionsData(
  filterData: ModalFilterDataType,
): filterData is ModalSortOptionsData {
  return (filterData as ModalSortOptionsData).sortSelection !== undefined;
}
